import { Dtos, type SuretyAccountId, type SuretyQuoteId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { bondRequestLatestUnderwritingQueryKey } from "../bond-request.keys";

export const useAdminFetchLatestSuretyQuoteUnderwriting = (
	accountId: SuretyAccountId,
	quoteId: SuretyQuoteId,
) => {
	const { get } = useRequest();

	const { data, error, isFetching, isLoading, refetch } = useQuery({
		queryKey: bondRequestLatestUnderwritingQueryKey(quoteId),
		queryFn: () =>
			get<Dtos.Admin.Quote.Underwriting | null>(
				`/v2/admin/surety/accounts/${accountId}/quotes/${quoteId}/underwritings/latest`,
			),
		retry: false,
		meta: { suppressErrorModal: true },
	});

	return {
		latestUnderwriting: data,
		latestUnderwritingError: error,
		latestUnderwritingIsFetching: isFetching,
		latestUnderwritingIsLoading: isLoading,
		refetchLatestUnderwriting: refetch,
	};
};
